import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, BookOpen, ListChecks, MapPin } from 'lucide-react';
import Tooltip from '../../ui/Tooltip/Tooltip';
import waiveraLogo from '../../../assets/images/sidebarlogo.svg';
import './ResourceLinkPreviews.css';

interface Props {
  href: string;
  title: string;
  kind: 'Resource' | 'Task' | 'FAQ';
  preview: React.ReactNode;
  appearance?: 'dark';
  onPreview?: () => void;
}

/** Presentation only: callers resolve current access and titles before rendering. */
export default function ChatReferenceChip({ href, title, kind, preview, appearance, onPreview }: Props) {
  const Icon = kind === 'Task' ? ListChecks : kind === 'FAQ' ? BookOpen : MapPin;
  return <Tooltip position="top" className={`resource-reference-tooltip${appearance === 'dark' ? ' resource-reference-chips--dark' : ''}`} content={preview}>
    <Link className="resource-reference-chip" to={href} aria-label={`Open ${kind.toLowerCase()}: ${title}`} onMouseEnter={onPreview} onFocus={onPreview}>
      <span className="resource-reference-brand"><img src={waiveraLogo} alt="Waivera" /></span>
      <span className="resource-reference-caption"><span className="resource-reference-kind"><Icon size={11} aria-hidden="true" />{kind}</span><span className="resource-reference-name">{title}</span></span>
      <ArrowUpRight size={16} aria-hidden="true" className="resource-reference-arrow" />
    </Link>
  </Tooltip>;
}
